import _ from 'lodash'

const areas = {
  computed: {
    areas () {
      return _.map(_.keys(this.innerValue.area), 
        (key)=>{ return { text:this.innerValue.area[key].name, value:key } })
    }
  }
}

const worlds = {
  props: {
    worlds: Array
  },
  computed: {
    worldsMap () {
      return _.transform(this.worlds, (result, c)=>{
        result[c.RID] = c
      },{})
    },
    worldsSelect () {
      return _.map(this.worlds, 
        (v)=>{ return { text:v.name, value:v.RID } })
    },
    openCardWorldsSelect () {
      return _.map(_.filter(this.worlds, v=>v.openCard), 
        (v)=>{ return { text:v.name, value:v.RID } })
        .concat([{ text:"-", value:null }])
    },
  }
}

const cards = {
  props: {
    importCard: Array,
  },
  computed: {
    cardList () {
      return _.concat(this.myCardList, this.importCardList)
    },
    myCardList () {
      return _.transform(this.innerValue.card, (result,c,i)=>{
        let info = _.find(c, { '@method':'info', args:{type:'skill'} })
        let init = _.find(c, {'@method':'init'}).args
        if(info){
          result.push({
            value: init.key,
            index: i,
            name: info.args.name,
            icon: info.args.icon,
            text: info.args.name,
            memo: info.args.memo,
          })
        }
      },[])
    },
    importCardList () {
      return _.transform(this.importCard, (result,c,i)=>{
        let info = _.find(c, { '@method':'info', args:{type:'skill'} })
        let init = _.find(c, {'@method':'init'}).args
        if(info){
          result.push({
            value: init.key,
            index: i,
            name: info.args.name,
            icon: info.args.icon,
            text: info.args.name,
            memo: info.args.memo,
            readonly: true,
          })
        }
      },[])
    },
    cardDict () {
      return _.assign(this.myCardDict, this.importCardDict)
    },
    myCardDict () {
      return _.transform(this.innerValue.card, (result,c,i)=>{
        let info = _.find(c, { '@method':'info', args:{type:'skill'} })
        let init = _.find(c, {'@method':'init'}).args
        if(info){
          result[init.key] = {
            value: init.key,
            index: i,
            name: info.args.name,
            icon: info.args.icon,
            text: info.args.name,
            memo: info.args.memo,
          }
        }
      },{})
    },
    importCardDict () {
      return _.transform(this.importCard, (result,c,i)=>{
        let info = _.find(c, { '@method':'info', args:{type:'skill'} })
        let init = _.find(c, {'@method':'init'}).args
        if(info){
          result[init.key] = {
            value: init.key,
            index: i,
            name: info.args.name,
            icon: info.args.icon,
            text: info.args.name,
            memo: info.args.memo,
            readonly: true,
          }
        }
      },{})
    },
    buffList () {
      return _.concat(this.myBuffList, this.importBuffList)
    },
    myBuffList () {
      let list = []
      this.innerValue.card.forEach((v,i)=>{
        let e = _.find(v, { '@method':'info', args:{type:'buff'} })
        if(e){
          list.push({
            index: i,
            name: e.args.name,
            icon: e.args.icon
          })
        }
      })
      return list
    },
    importBuffList () {
      let list = []
      this.importCard.forEach((v,i)=>{
        let e = _.find(v, { '@method':'info', args:{type:'buff'} })
        if(e){
          list.push({
            index: i,
            name: e.args.name,
            icon: e.args.icon,
            readonly: true,
          })
        }
      })
      return list
    }
  }  
}

const _fixStatus = ['STR','INT','VIT','MND','DEX','AGI','HP','EP']
const fixStatus = {
  computed: {
    fixStatus () { return _fixStatus },
    chunk2fixStatus () { return _.chunk(_fixStatus,2 ) },
    chunk4fixStatus () { return _.chunk(_fixStatus,4 ) },
  }
}

export {
  areas,
  cards,
  worlds,
  fixStatus
}
